



































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';

@Component({
    components: {},
    watch: {
        loading: function (val, oldValue) {
            if (!val && oldValue) {
                (this as any).init();
            }
        }
    }
})
export default class DealerMap extends ListBase {
    selected: number = null;
    selectedDealer: number = null;
    lat: string = "-12.05";
    lng: string = "-77.05";
    lastId: number = null;

    get simplemaps_countrymap() {
        return (window as any).simplemaps_countrymap;
    }
    
    get list() {
        let list = [];
        let vm = this;
        this.$store.state.dealer.mapList.forEach(deal => {
            let item = Util.extend(true, {}, deal);
            if (item.department != null) {
                let idx = vm.departments.indexOf(item.department.name);
                item.code = 'PER' + (idx + 566 + (idx > 9 ? 1 : 0));
                item.department = item.department.name;
                list.push(item);
            }
        });

        return list;
    }

    get loading() {
        return this.$store.state.dealer.loading;
    }

    get zones() {
        let list = [];
        let vm = this;
        this.$store.state.dealer.mapList.forEach(item => {
            if (list[item.zone_id] == undefined) list[item.zone_id] = { id: item.zone_id, name: item.zone.name, color: item.zone.color, manager: (item.zone.manager != null ? item.zone.manager.fullname : ''), dealers: []}

            list[item.zone_id].dealers.push({ id: item.id, code: item.code, name: item.fullname, lat: item.lat, lng: item.lng});
        });

        return list;
    }

    get departments() {
        return [
            "Lambayeque", "Piura", "Tumbes", "Apurimac", "Arequipa", "Cusco", "Madre de Dios", "Puno", "Moquegua", "Tacna", "Ancash","Cajamarca",                
            "Huanuco", "La Libertad", "Pasco","San Martin","Ucayali","Amazonas","Loreto","Ayacucho","Lima Province","Huancavelica",                
            "Ica","Junin","Lima"];
    }
    
    changeDealer(item) {
        if (item == undefined) {
            //let vm = this;
            //setTimeout(() => {
            //    vm.simplemaps_countrymap.back();
            //    this.selectedDealer = null;
            //}, 700);
        }
            
    }

    selectDealer(item) {
        this.$store.commit('app/setDealer', [item.id]);
        Util.toRoute(this, 'workshopinfo');
        //this.selectedDealer = item.id;
        //this.simplemaps_countrymap.state_zoom(item.code);  
    }

    make_colors() {
        let totals = [];

        this.list.forEach(item => {
            if (this.simplemaps_countrymap.mapdata.state_specific[item.code] != undefined) {
                if (totals[item.code] == undefined) totals[item.code] = 0;
                totals[item.code]++;
                this.simplemaps_countrymap.mapdata.state_specific[item.code].color = item.zone.color.substr(0, 7);
                this.simplemaps_countrymap.mapdata.state_specific[item.code].name = item.department + '(' + totals[item.code]+')';
            }
            let typ = Util.getTypeValueById(item.type_id);
            this.simplemaps_countrymap.mapdata.locations[item.id] = {
                lat: item.lat,
                lng: item.lng,
                name: item.fullname,
                image_url: '/img/gps.png',
                description: typ.name
            };
        });

        this.simplemaps_countrymap.refresh();
    }

    showPin(item) {
        if (this.lastId != item.id) {
            this.list.forEach(item => {
                this.simplemaps_countrymap.mapdata.locations[item.id].image_url = '/img/gps.png';
            });

            if (item.lat != null && item.lng != null) {
                this.simplemaps_countrymap.mapdata.locations[item.id].image_url = '/img/gps_on.png';
            }

            this.simplemaps_countrymap.refresh();
            this.lastId = item.id;
        }
    }

    init() {
        this.simplemaps_countrymap.load();
        this.make_colors();
    }

    async mounted() {
        await this.$store.dispatch({ type: 'dealer/getMapList' });

        this.init();
    }

    created() {
        
    }
}